import { Base, Company, EmployeeAccess, LoginResponse } from '@akiba/models_beta_temp';
import { Params } from '@angular/router';
import { LocalStorageEnum } from './enums';
import { LocalStorage } from './localStorage';

export class ViewerInfo {
  uid: string = '';
  userName: string = '';
  company: Company | undefined;
  access: any;
  companies: any;

  constructor(){}

  loadFromLoginResult(lr: LoginResponse) {
    this.uid = lr.uid;
    this.userName = lr.userName;
    this.access = lr.userAccess;
    this.companies = lr.userCompanies;
    this.company = this.defaultCompany();
  }

  loadFromSession(): boolean {

    const stored: any | undefined = LocalStorage.getFromStorage(LocalStorageEnum.ViewerInfoResponse);
    if (stored) {
      this.uid = stored.uid;
      this.userName = stored.userName;
      this.access = stored.access;
      this.companies = stored.companies;
      this.company = this.loadCurrentCompany();
      return true;
    }
    return false;
  }

  loadFromParams(params: Params): boolean {

    let result = false;

    if (params.companyID) {
      this.company = new Company({companyID: params.companyID});
      LocalStorage.saveToStorage(LocalStorageEnum.CurrentUserCompany, params.companyID);
      result = true;
    }

    if (params.userName) {
      this.userName = params.userName;
      result = true;
    }

    if (params.uid) {
      this.uid = params.uid;
      result = true;
    }

    return result;
  }

  loadCurrentCompany(): Company | undefined {

    const companyID = LocalStorage.getFromStorage(LocalStorageEnum.CurrentUserCompany);
    if (companyID) {
      const aCompany = new Company(this.companies[companyID]);
      this.company = aCompany;
      return this.company;
    }

    return this.defaultCompany();

  }

  defaultCompany(): Company | undefined {

    let def: Company | undefined;
    let cc: string | undefined = LocalStorage.getFromStorage(LocalStorageEnum.CurrentUserCompany);
    if (!cc) {
      const userCompanies = this.companies;
      cc = Object.keys(userCompanies)[0];
      LocalStorage.saveToStorage(LocalStorageEnum.CurrentUserCompany, cc);
      def = cc ? new Company(this.companies[cc]) : undefined;
    }

    return def;

  }

  saveForSession(): boolean {
    const obj: any = {
      uid: this.uid,
      userName: this.userName,
      access: this.access,
      companies: this.companies,
      company: this.company ? this.company.toAny() : undefined,
    }
    return LocalStorage.saveToStorage(LocalStorageEnum.ViewerInfoResponse, obj);
  }

}

